/* Austropool — Auto-Verlinkung im Ratgeber-Text.
   Verlinkt die erste Erwähnung bekannter Begriffe im Artikel-Fließtext
   mit Shop-Kategorien/Produkten. DOM-basiert: fasst nur Textknoten an,
   nie bestehende Links, nie Überschriften. Max. 5 Links je Artikel. */
(function () {
  var MAP = [
    [/\bSandfilteranlagen?\b/, '/collections/pool-sandfilteranlage'],
    [/\b(?:Pool-?)?[Ff]ilterpumpen?\b|\bPoolpumpen?\b/, '/collections/pool-filterpumpe'],
    [/\bPoolfolien?\b/, '/collections/poolfolie'],
    [/\bWinterabdeckplanen?\b|\bAbdeckplanen?\b/, '/products/winterabdeckplane-fur-ovalpools-180-g-m'],
    [/\bDesalgin\b|\bAlgenmittel\b|\bAlgizid\b/, '/products/bayrol-desalgin-3l'],
    [/\bSuperflock\b|\bFlockungsmittel\b|\bFlockmittel\b/, '/products/bayrol-kartuschen-superflock-1kg'],
    [/\bPooltester\b|\bWassertester\b/, '/products/pooltester-manuell-chlor-ph'],
    [/\bSkimmer\b(?!klappe)/, '/collections/skimmer'],
    [/\bWärmepumpen?\b/, '/collections/pool-warmepumpe-inverter'],
    [/\bPoolroboter\b/, '/collections/poolroboter'],
    [/\bSolarplanen?\b|\bSolarfolie\b/, '/collections/solarplane'],
    [/\bPuripool\b|\bÜberwinterungsmittel\b/, '/products/bayrol-puripool-3l'],
    [/\b[Ee]inwintern\b|\bEinwinterung\b/, '/collections/pool-einwintern'],
    [/\bStyropor[- ]?[Pp]ools?\b/, '/collections/styropor-pool'],
    [/\bSicherheitsabdeckungen?\b/, '/collections/sicherheitsabdeckungen'],
    [/\bPool-?[Üü]berdachung(?:en)?\b/, '/collections/pool-uberdachungen'],
    [/\bPoolabdeckung(?:en)?\b/, '/pages/poolabdeckung-pool-uberdachung'],
    [/\bHolzpools?\b/, '/collections/holzpool'],
    [/\bPoolheizung(?:en)?\b/, '/pages/poolheizung'],
    [/\bChlortabletten\b|\bChlorgranulat\b|\bMultifunktionstabletten\b/, '/collections/poolpflege-chlor'],
    [/\bpH-(?:Minus|Plus|Heber|Senker)\b/, '/collections/ph-wert-regulierung'],
    [/\bStarter-?[Ss]et\b/, '/products/bayrol-poolpflege-starter-set-klein-5in1-fur-pool-neulinge']
  ];
  var MAX = 5;

  function run() {
    var root = document.querySelector('.article-template .rte, .article-template__content');
    if (!root) return;
    var used = {};
    document.querySelectorAll('.article-template a[href]').forEach(function (a) {
      used[a.getAttribute('href')] = true;
    });
    var added = 0;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var el = node.parentElement;
        while (el && el !== root) {
          var tag = el.tagName;
          if (tag === 'A' || tag === 'H1' || tag === 'H2' || tag === 'H3' || tag === 'H4' || tag === 'BUTTON') {
            return NodeFilter.FILTER_REJECT;
          }
          el = el.parentElement;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (var n = 0; n < nodes.length && added < MAX; n++) {
      var node = nodes[n];
      for (var i = 0; i < MAP.length && added < MAX; i++) {
        var re = MAP[i][0], url = MAP[i][1];
        if (used[url]) continue;
        var m = re.exec(node.nodeValue);
        if (!m) continue;
        var a = document.createElement('a');
        a.href = url;
        a.textContent = m[0];
        var rest = node.splitText(m.index);
        rest.nodeValue = rest.nodeValue.slice(m[0].length);
        rest.parentNode.insertBefore(a, rest);
        used[url] = true;
        added++;
        node = rest;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
